import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styles: [
    `
      .custom-shadow {
        box-shadow: 2px 4px 12px 0px #0000001a;
      }

      .custom-shadow-larger {
        box-shadow: 2px 4px 12px 0px #0000001a;
      }

      .hide-bar::-webkit-scrollbar {
        display: none;
      }
    `,
  ],
  standalone: false,
})
export class CalendarComponent implements OnInit, OnChanges {
  constructor() {}
  @Input() backgroundImage = '';
  @Input() canResizeEvents = true;
  @Input() weeklyShowHoursMode: 'weekly' | 'daily' = 'weekly';
  @Input() weeklyHours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];
  @Input() daysToRemove: any = [];
  @Input() arrayEvents: any = [];
  @Input() mobileItems: any[] = [];
  @Input() currentDate: any = new Date();
  @Input() weekly: boolean = false;
  @Input() show: boolean = false;
  @Input() daysOff = [0, 6];
  @Input() showAllEvents: boolean = false;
  @Input() translatePipe: any;
  @Input() scrollHours: boolean = false;
  @Input() hoursToScroll: number = 12;
  @Output() onDayClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() currentWeek: EventEmitter<any> = new EventEmitter<any>();
  @Output() currentMonthYear: EventEmitter<any> = new EventEmitter<any>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() showEvent: EventEmitter<any> = new EventEmitter<any>();
  generatedArrayCalendar: any[] = [];
  currentMonthToDisplay = '';
  eventTime: any;
  currentMonthDays = 0;
  arrayCalendar: any = [];
  currentDay = new Date(this.currentDate).getDate();
  daySelected: any = null;
  closeOnOutside: boolean = true;
  maxVisibleEvents: number = 2;
  nameModal: string = '';
  dateStartModal: any;
  dateEndModal: any;
  descriptionModal: string = '';
  luogoModal: string = '';
  partecipantiModal: string = '';
  linkModal: string = '';
  details: any[] = [];
  more: boolean = true;
  selectedIndex: number = -1;
  select: boolean = false;
  grabbedStatus: number = 0; // 0 Non c'è nulla grabbato,1 hai grabbato la startDate,2 hai grabbato la endDate
  inizialGrabbedPosition = -1; //Indica la posizione rispetto alla schermo come altezza
  selectedEventId = '';
  initialEventH = 0;
  todayDate = {
    day: new Date().getDate(),
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  };

  closeModal() {
    this.show = false;
    this.close.emit(this.show);
  }

  getEventTime(timestamp: number): string {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getEventTimeHours(timestamp: number): number {
    const date = new Date(timestamp);
    const hours = date.getHours();
    return hours;
  }

  getTopWeekly(timestamp: number) {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours * 50 + (minutes / 60) * 50;
  }

  getHWeekly(timestamp: number, end: number) {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const totalValueStart = hours * 60 + minutes;
    const dateEnd = new Date(end);
    const hoursEnd = dateEnd.getHours();
    const minutesEnd = dateEnd.getMinutes();
    const totalValueEnd = hoursEnd * 60 + minutesEnd;
    return ((totalValueEnd - totalValueStart) / 60) * 50;
  }

  getEventTimeMinutes(timestamp: number): number {
    const date = new Date(timestamp);
    const minutes = date.getMinutes();
    return minutes;
  }

  showDetails(event: any) {
    this.details = [event];
  }

  showMore(event: any, index: number) {
    this.more = !this.more;
    this.selectedIndex = index;
    this.nameModal = event.name;
    this.dateStartModal = event.dateStart;
    this.dateEndModal = event.dateEnd;
    this.descriptionModal = event.descrizione;
    this.luogoModal = event.luogo;
    this.partecipantiModal = event.partecipanti;
    this.linkModal = event.link;
  }

  openEvent(event: any) {
    this.showEvent.emit(event);
    this.nameModal = event.name;
    this.dateStartModal = event.dateStart;
    this.dateEndModal = event.dateEnd;
    this.descriptionModal = event.descrizione;
    this.luogoModal = event.luogo;
    this.partecipantiModal = event.partecipanti;
    this.linkModal = event.link;
    this.show = !this.show;
  }

  scrollTo(id: string) {
    setTimeout(() => {
      let elementToscroll = document.getElementById(id);
      if (elementToscroll) {
        elementToscroll.scrollIntoView();
      }
    }, 0);
  }

  getFormattedDate(timestamp: number): string {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString('it-IT', { month: 'long' });
    return `${day} ${month}`;
  }

  handleClose(event: boolean) {
    this.show = event;
    this.close.emit(this.show);
  }

  nextMonth() {
    let current = new Date(this.currentDate);
    const nextMonthDate = new Date(
      current.getFullYear(),
      current.getMonth() + 1,
      1
    );
    this.currentDate = nextMonthDate;
    this.generateCalendar();

    const nextMonth = nextMonthDate;
    const nextYear = nextMonthDate.getFullYear();
    // this.currentMonthYear.emit({ nextMonth, nextYear });
    this.currentMonthToDisplay = this.getCurrentMonthYear();
  }

  previousMonth() {
    let current = new Date(this.currentDate);
    this.currentDate = new Date(current.getFullYear(), current.getMonth() - 1);
    this.generateCalendar();
    // this.currentMonthYear.emit({ nextMonth: this.currentDate });
    this.currentMonthToDisplay = this.getCurrentMonthYear();
  }

  getCurrentMonthYear(): string {
    const firstDay = new Date(this.generateArrayCalendar()[0].date);
    const lastDay = new Date(
      this.generateArrayCalendar()[
        this.generateArrayCalendar()?.length - 1
      ].date
    );
    if (firstDay.getMonth() == lastDay.getMonth()) {
      return `${firstDay.getDate()} - ${lastDay.getDate()} ${this.translatePipe(
        'months.' + firstDay.getMonth()
      )}`;
    } else {
      return `${firstDay.getDate()} ${this.translatePipe(
        'months.' + firstDay.getMonth()
      )} - ${lastDay.getDate()} ${this.translatePipe(
        'months.' + lastDay.getMonth()
      )}`;
    }
  }

  selectDay(day: any) {
    this.daySelected = day;
    this.onDayClick.emit(day);
  }

  generateCalendar() {
    this.weekly = false;
    this.select = false;
    let date = new Date(this.currentDate);
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    this.currentMonthDays = new Date(
      currentYear,
      currentMonth + 1,
      0
    ).getDate();
    this.arrayCalendar = Array.from(Array(this.currentMonthDays).keys()).map(
      (today) => {
        let myEvents = this.arrayEvents.filter((event: any) => {
          let dateOfEvent = new Date(event.dateStart);
          let myDate = new Date(
            new Date().setFullYear(currentYear, currentMonth, today + 1)
          );

          if (
            myDate.getFullYear() === dateOfEvent.getFullYear() &&
            myDate.getMonth() === dateOfEvent.getMonth() &&
            myDate.getDate() === dateOfEvent.getDate()
          ) {
            return event;
          }
        });
        let day = {
          day: today + 1,
          events: myEvents,
          year: currentYear,
          date: new Date().setFullYear(currentYear, currentMonth, today + 1),
          week: new Date(
            new Date().setFullYear(currentYear, currentMonth, today + 1)
          ).getDay(),
        };
        return day;
      }
    );

    const firstDayOfWeek = 1;

    if (this.arrayCalendar[0]?.week !== firstDayOfWeek) {
      let beforeDays: any = [];
      let startDayOfWeek =
        (this.arrayCalendar[0]?.week - firstDayOfWeek + 7) % 7;

      if (startDayOfWeek > 0) {
        beforeDays = Array.from(Array(startDayOfWeek).keys())
          .map((res: any) => {
            let myEvents = this.arrayEvents.filter((event: any) => {
              let dateOfEvent = new Date(event.dateStart);
              let myDate = new Date(
                new Date(date).setFullYear(currentYear, currentMonth, res * -1)
              );

              if (
                myDate.getFullYear() === dateOfEvent.getFullYear() &&
                myDate.getMonth() === dateOfEvent.getMonth() &&
                myDate.getDate() === dateOfEvent.getDate()
              ) {
                return event;
              }
            });

            return {
              day: new Date(
                new Date(date).setFullYear(currentYear, currentMonth, res * -1)
              ).getDate(),
              date: new Date(date).setFullYear(
                currentYear,
                currentMonth,
                res * -1
              ),
              week: new Date(
                new Date(date).setFullYear(currentYear, currentMonth, res * -1)
              ).getDay(),
              off: true,
              events: myEvents,
            };
          })
          .reverse();
      }
      this.arrayCalendar = [...beforeDays, ...this.arrayCalendar];
    }

    if (
      this.arrayCalendar[this.currentMonthDays - 1]?.week !==
      (firstDayOfWeek + 5) % 7
    ) {
      let newLastDays = [];
      let endDayOfWeek =
        (7 -
          this.arrayCalendar[this.currentMonthDays - 1]?.week +
          firstDayOfWeek -
          1) %
        7;

      if (endDayOfWeek > 0) {
        newLastDays = Array.from(Array(endDayOfWeek).keys()).map((res: any) => {
          let myEvents = this.arrayEvents.filter((event: any) => {
            let dateOfEvent = new Date(event.dateStart);
            let myDate = new Date(
              new Date(
                this.arrayCalendar[this.currentMonthDays - 1].date
              ).setDate(
                new Date(
                  this.arrayCalendar[this.currentMonthDays - 1].date
                ).getDate() +
                  res +
                  1
              )
            );

            if (
              myDate.getFullYear() === dateOfEvent.getFullYear() &&
              myDate.getMonth() === dateOfEvent.getMonth() &&
              myDate.getDate() === dateOfEvent.getDate()
            ) {
              return event;
            }
          });
          return {
            day: res + 1,
            events: myEvents,
            date: new Date(
              this.arrayCalendar[this.currentMonthDays - 1].date
            ).setDate(
              new Date(
                this.arrayCalendar[this.currentMonthDays - 1].date
              ).getDate() +
                res +
                1
            ),
            week:
              (this.arrayCalendar[this.currentMonthDays - 1]?.week + res + 1) %
              7,
            off: true,
          };
        });
        this.arrayCalendar = [...this.arrayCalendar, ...newLastDays];
      }
    }

    let firstDate = new Date(
      new Date(new Date(new Date(date).setHours(0)).setMinutes(0)).setSeconds(0)
    );
    let lastDate = new Date(
      new Date(
        new Date(
          new Date(
            this.arrayCalendar[this.arrayCalendar.length - 1].date
          ).setHours(24)
        ).setMinutes(0)
      ).setSeconds(0)
    );
    this.currentMonthToDisplay = this.getCurrentMonthYear();
    this.currentMonthYear.emit({ firstDate: firstDate, lastDate: lastDate });
  }

  currentMonth!: number;
  currentYear!: number;

  ngOnInit() {
    const today = new Date();
    this.currentDay = today.getDate();
    this.currentMonthDays = today.getMonth();
    this.currentYear = today.getFullYear();
    const currentDate = `${this.currentYear}-${this.currentMonth}-${this.currentDay}`;
    this.daySelected = this.arrayCalendar.find(
      (day: { date: string }) => day.date === currentDate
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['arrayEvents'] || changes['weekly']) {
      this.generatedArrayCalendar = this.generateArrayCalendar();
    }
    if (changes['currentDate']) {
      this.currentMonthToDisplay = this.getCurrentMonthYear();
    }
  }

  generateArrayCalendar() {
    if (this.weekly) {
      let currentDate = new Date(this.currentDate);
      let currentYear = currentDate.getFullYear();
      let currentMonth = currentDate.getMonth();
      let currentDay = currentDate.getDate();
      let currentWeekday = currentDate.getDay();

      // Calcola l'inizio della settimana (lunedì)
      const firstDayOfWeek = new Date(currentDate);
      firstDayOfWeek.setDate(currentDay - (currentWeekday - 1)); // Shift to Monday

      // Calcola la fine della settimana (domenica)
      const lastDayOfWeek = new Date(currentDate);
      lastDayOfWeek.setDate(currentDay + (7 - currentWeekday)); // Shift to Sunday

      this.arrayCalendar = Array.from(Array(7).keys()).map((index) => {
        let day = new Date(firstDayOfWeek);
        day.setDate(firstDayOfWeek.getDate() + index);

        let myEvents = this.arrayEvents.filter((event: any) => {
          event.index = this.getIndexByDate(event.startDate);
          event.iToVisualize = 0;
          let dateOfEvent = new Date(event.dateStart);
          return (
            day.getFullYear() === dateOfEvent.getFullYear() &&
            day.getMonth() === dateOfEvent.getMonth() &&
            day.getDate() === dateOfEvent.getDate()
          );
        });
        myEvents.map((myEventToEdit: any) => {
          myEventToEdit.indexW = 0;
          let numberOfItemsWithSimilarIndex = JSON.parse(
            JSON.stringify(myEvents)
          ).filter(
            (myEToF: any) =>
              myEToF.index + 30 >= myEventToEdit.index &&
              myEToF.index - 30 <= myEventToEdit.index
          ).length;
          let numberOfItemsWithSameIndex = JSON.parse(
            JSON.stringify(myEvents)
          ).filter((myEToF: any) => myEToF.index == myEventToEdit.index).length;

          if (
            numberOfItemsWithSameIndex > 1 ||
            numberOfItemsWithSimilarIndex > 1
          ) {
            let currentIndexOfFillteredWithSameIndex = JSON.parse(
              JSON.stringify(myEvents)
            )
              .filter((myEToF: any) => myEToF.index == myEventToEdit.index)
              .findIndex(
                (myEToFindSame: any) => myEToFindSame.id == myEventToEdit.id
              );
            let currentIndexOfFillteredWithSimilarIndex = JSON.parse(
              JSON.stringify(myEvents)
            )
              .filter(
                (myEToF: any) =>
                  myEToF.index + 30 >= myEventToEdit.index &&
                  myEToF.index - 30 <= myEventToEdit.index
              )
              .findIndex(
                (myEToFindSame: any) => myEToFindSame.id == myEventToEdit.id
              );
            myEventToEdit.indexW = currentIndexOfFillteredWithSimilarIndex;
          }
          let currentIndexOfFillteredWithSimilarIndex = JSON.parse(
            JSON.stringify(myEvents)
          )
            .filter(
              (myEToF: any) =>
                myEToF.index + 30 >= myEventToEdit.index &&
                myEToF.index - 30 <= myEventToEdit.index
            )
            .findIndex(
              (myEToFindSame: any) => myEToFindSame.id == myEventToEdit.id
            );
          myEventToEdit.width =
            100 /
            JSON.parse(JSON.stringify(myEvents)).filter(
              (myEToF: any) =>
                myEToF.index + 30 >= myEventToEdit.index &&
                myEToF.index - 30 <= myEventToEdit.index
            ).length;
          if (currentIndexOfFillteredWithSimilarIndex == 0) {
            myEventToEdit.width = 100;
          }
          return myEventToEdit;
        });
        return {
          day: day.getDate(),
          month: day.getMonth(),
          events: myEvents,
          date: day.getTime(),
          year: day.getFullYear(),
          week: (index + 1) % 7, // Adjust day of week to start with Monday (0 for Monday, 6 for Sunday)
        };
      });
    } else {
      let date = new Date(this.currentDate);
      let currentYear = date.getFullYear();
      let currentMonth = date.getMonth();
      this.currentMonthDays = new Date(
        currentYear,
        currentMonth + 1,
        0
      ).getDate();
      this.arrayCalendar = Array.from(Array(this.currentMonthDays).keys()).map(
        (today) => {
          let myEvents = this.arrayEvents.filter((event: any) => {
            let dateOfEvent = new Date(event.dateStart);
            let myDate = new Date(
              new Date().setFullYear(currentYear, currentMonth, today + 1)
            );

            if (
              myDate.getFullYear() === dateOfEvent.getFullYear() &&
              myDate.getMonth() === dateOfEvent.getMonth() &&
              myDate.getDate() === dateOfEvent.getDate()
            ) {
              return event;
            }
          });
          let day = {
            day: today + 1,
            events: myEvents,
            year: currentYear,
            date: new Date().setFullYear(currentYear, currentMonth, today + 1),
            month: new Date(
              new Date().setFullYear(currentYear, currentMonth, today + 1)
            ).getMonth(),
            week: new Date(
              new Date().setFullYear(currentYear, currentMonth, today + 1)
            ).getDay(),
          };
          return day;
        }
      );

      const firstDayOfWeek = 1;

      if (this.arrayCalendar[0]?.week !== firstDayOfWeek) {
        let beforeDays: any = [];
        let startDayOfWeek =
          (this.arrayCalendar[0]?.week - firstDayOfWeek + 7) % 7;

        if (startDayOfWeek > 0) {
          beforeDays = Array.from(Array(startDayOfWeek).keys())
            .map((res: any) => {
              let myEvents = this.arrayEvents.filter((event: any) => {
                let dateOfEvent = new Date(event.dateStart);
                let myDate = new Date(
                  new Date(date).setFullYear(
                    currentYear,
                    currentMonth,
                    res * -1
                  )
                );

                if (
                  myDate.getFullYear() === dateOfEvent.getFullYear() &&
                  myDate.getMonth() === dateOfEvent.getMonth() &&
                  myDate.getDate() === dateOfEvent.getDate()
                ) {
                  return event;
                }
              });

              return {
                day: new Date(
                  new Date(date).setFullYear(
                    currentYear,
                    currentMonth,
                    res * -1
                  )
                ).getDate(),
                date: new Date(date).setFullYear(
                  currentYear,
                  currentMonth,
                  res * -1
                ),
                week: new Date(
                  new Date(date).setFullYear(
                    currentYear,
                    currentMonth,
                    res * -1
                  )
                ).getDay(),
                off: true,
                events: myEvents,
              };
            })
            .reverse();
        }
        this.arrayCalendar = [...beforeDays, ...this.arrayCalendar];
      }

      if (
        this.arrayCalendar[this.currentMonthDays - 1]?.week !==
        (firstDayOfWeek + 5) % 7
      ) {
        let newLastDays = [];
        let endDayOfWeek =
          (7 -
            this.arrayCalendar[this.currentMonthDays - 1]?.week +
            firstDayOfWeek -
            1) %
          7;

        if (endDayOfWeek > 0) {
          newLastDays = Array.from(Array(endDayOfWeek).keys()).map(
            (res: any) => {
              let myEvents = this.arrayEvents.filter((event: any) => {
                let dateOfEvent = new Date(event.dateStart);
                let myDate = new Date(
                  new Date(
                    this.arrayCalendar[this.currentMonthDays - 1].date
                  ).setDate(
                    new Date(
                      this.arrayCalendar[this.currentMonthDays - 1].date
                    ).getDate() +
                      res +
                      1
                  )
                );

                if (
                  myDate.getFullYear() === dateOfEvent.getFullYear() &&
                  myDate.getMonth() === dateOfEvent.getMonth() &&
                  myDate.getDate() === dateOfEvent.getDate()
                ) {
                  return event;
                }
              });
              return {
                day: res + 1,
                events: myEvents,
                date: new Date(
                  this.arrayCalendar[this.currentMonthDays - 1].date
                ).setDate(
                  new Date(
                    this.arrayCalendar[this.currentMonthDays - 1].date
                  ).getDate() +
                    res +
                    1
                ),
                week:
                  (this.arrayCalendar[this.currentMonthDays - 1]?.week +
                    res +
                    1) %
                  7,
                off: true,
              };
            }
          );
          //, ...newLastDays
          this.arrayCalendar = [...this.arrayCalendar];
        }
      }
    }
    return this.arrayCalendar;
  }

  startGrabEvent(event: any, eventId: string, status: number) {
    this.grabbedStatus = status;
    this.selectedEventId = eventId;
    let myGrabbedEvent = document.getElementById(eventId);
    if (myGrabbedEvent) {
      this.initialEventH = myGrabbedEvent.clientHeight;
    }
    this.inizialGrabbedPosition = event.clientY;
  }

  getIndexByDate(date: any) {
    return new Date(date).getHours() * 60 + new Date(date).getMinutes();
  }

  moveEvent(event: any) {
    if (this.grabbedStatus > 0) {
      let myEventToAdjust = document.getElementById(this.selectedEventId);
      if (myEventToAdjust) {
        let hToAdd = 0;
        if (event.clientY > this.inizialGrabbedPosition) {
          hToAdd =
            this.initialEventH + event.clientY - this.inizialGrabbedPosition;
          if (hToAdd < 25) {
            hToAdd = 25;
          }
        }
        if (event.clientY < this.inizialGrabbedPosition) {
          hToAdd = -5;
        }
        let finalH = myEventToAdjust.clientHeight + hToAdd;
        myEventToAdjust.style.height = hToAdd + 'px';
      }
    }
  }
  endGrabEvent(event: any) {
    this.grabbedStatus = 0;
  }

  generateWeeklyCalendar() {
    this.weekly = true;
    this.select = false;
    let currentDate = new Date(this.currentDate);
    let currentYear = currentDate.getFullYear();
    let currentMonth = currentDate.getMonth();
    let currentDay = currentDate.getDate();
    let currentWeekday = currentDate.getDay();

    // Calcola l'inizio della settimana (lunedì)
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDay - (currentWeekday - 1)); // Shift to Monday

    // Calcola la fine della settimana (domenica)
    const lastDayOfWeek = new Date(currentDate);
    lastDayOfWeek.setDate(currentDay + (7 - currentWeekday)); // Shift to Sunday

    this.arrayCalendar = Array.from(Array(7).keys()).map((index) => {
      let day = new Date(firstDayOfWeek);
      day.setDate(firstDayOfWeek.getDate() + index);

      let myEvents = this.arrayEvents.filter((event: any) => {
        let dateOfEvent = new Date(event.dateStart);
        return (
          day.getFullYear() === dateOfEvent.getFullYear() &&
          day.getMonth() === dateOfEvent.getMonth() &&
          day.getDate() === dateOfEvent.getDate()
        );
      });

      return {
        day: day.getDate(),
        events: myEvents,
        date: day.getTime(),
        week: (index + 1) % 7, // Adjust day of week to start with Monday (0 for Monday, 6 for Sunday)
      };
    });
    setTimeout(() => {
      this.currentMonthToDisplay = this.getCurrentMonthYear();
      const currentWeek = this.getCurrentWeek();
      this.currentWeek.emit(currentWeek);
    }, 0);
  }

  nextWeek() {
    let current = new Date(this.currentDate);
    let nextWeek = new Date(current);
    nextWeek.setDate(nextWeek.getDate() + 7);
    this.currentDate = nextWeek;
    this.generateWeeklyCalendar();
    setTimeout(() => {
      const currentWeek = this.getCurrentWeek();
      this.currentWeek.emit(currentWeek);
    }, 0);
    this.currentMonthToDisplay = this.getCurrentMonthYear();
  }
  getCurrentWeek(): any {
    const firstDay = this.arrayCalendar[0]?.date;
    const lastDay = this.arrayCalendar[this.arrayCalendar.length - 1]?.date;
    const firstDate = new Date(firstDay);
    const lastDate = new Date(lastDay);
    return { firstDate: firstDate, lastDate: lastDate };
  }

  previousWeek() {
    let current = new Date(this.currentDate);
    let previousWeek = new Date(current);
    previousWeek.setDate(previousWeek.getDate() - 7);
    this.currentDate = previousWeek;
    this.generateWeeklyCalendar();
    setTimeout(() => {
      const currentWeek = this.getCurrentWeek();
      this.currentWeek.emit(currentWeek);
    }, 0);
    this.currentMonthToDisplay = this.getCurrentMonthYear();
  }
}
